import React from 'react';
// import React, { Component } from 'react';
import { Field } from 'redux-form';

import classes from '../../../utils/cssClasses';
import RenderField from '../RenderField';


// export default evidenceRepeater;
export default function({fields}){
	return (
		<div >
	    {fields.map((evidence, index) =>
	      <div className={classes('card')} key={index}>
	      	<div className={classes('card-body')} key={index}>
		        <h4>
		        	Evidence #{index + 1}
			        <button
			          type="button"
			          title="Remove evidence"
			          className={classes('btn btn-link')}
			          onClick={() => fields.remove(index)}>
			          Remove
			         </button>
			      </h4>
		        <div className={classes('row')}>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${evidence}.id`}
				          type="text"
				          label="Url"
				          component={RenderField}
				          placeholder="Url"/>
		        		<small>The URI of a webpage presenting evidence of achievement.</small>
		        	</div>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${evidence}.narrative`}
				          type="text"
				          label="Narrative"
				          component={RenderField}
				          placeholder="Url"/>
		        		<small>A narrative that describes the evidence and process of achievement that led to an Assertion.  <b>Can be written in markdwon</b></small>
		        	</div>
		        	<div className={classes('col-12 ')}>
				        <Field
				          name={`${evidence}.description`}
				          label="Description"
				          type="textarea"
				          component={RenderField}
				          placeholder="Description"/>
		        		<small>	A longer description of the evidence.</small>
		          </div>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${evidence}.name`}
				          label="Name"
				          type="text"
				          component={RenderField}
				          placeholder="Name"/>
		        		<small>A descriptive title of the evidence.</small>
		        	</div>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${evidence}.genre`}
				          label="Genre"
				          type="text"
				          component={RenderField}
				          placeholder="Genre"/>
		        		<small>A string that describes the type of evidence. For example, Poetry, Prose, Film.</small>
		        	</div>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${evidence}.audience`}
				          label="Audience"
				          type="text"
				          component={RenderField}
				          placeholder="Audience"/>
		        		<small>A description of the intended audience for a piece of evidence.</small>
		        	</div>
		        </div>
		      </div>
		    </div>
	    )}
	    <button className={classes('btn btn-dark mt-3 mb-3')} type="button" onClick={() => {
	    	fields.push({})
	    	console.log(fields.length);
	    }}>Add evidence</button>
	  </div>
	);
}


// WEBPACK FOOTER //
// ./src/components/Backend/EvidenceRepeater/EvidenceRepeater.js